/**
 * Provides JS functionality for global search bar.
 */
class GlobalSearchBar extends DrupalBehavior {

  onContent(context) {
    let width = window.innerWidth;

    const open = () => {
      width = window.innerWidth;
      gsap.set(".global-search-bar", {
        display: 'block',
      });
      gsap.set(".global-search-bar__overlay", {
        display: 'block',
      });
      gsap.to(".global-search-bar", 0.5, {
        opacity: 1
      });
      $('.global-search-bar').addClass('global-search-bar--active');
      $('.search-toggle').addClass('search-toggle--open');
    };

    const close = () => {
      width = window.innerWidth;
      gsap.to(".global-search-bar", 0.5, {
        opacity: 0,
        onComplete: () => {
          if (!$('.global-search-bar').hasClass('global-search-bar--active')) {
            gsap.set(".global-search-bar", {
              display: 'none',
            });
            gsap.set(".global-search-bar__overlay", {
              display: 'none',
            });
          }
        },
      });
      $('.global-search-bar').removeClass('global-search-bar--active');
      $('.search-toggle').removeClass('search-toggle--open');
    }

    $('.global-search-bar__close', context).unbind('click').bind('click', (event) => {
      event.preventDefault();
      close();
    })

    $('.global-search-bar__overlay', context).unbind('click').bind('click', (event) => {
      event.preventDefault();
      close();
    })

    $('.search-toggle', context).unbind('click').bind('click', event => {
      event.preventDefault();
      if ($('.global-search-bar').hasClass('global-search-bar--active')) {
        close();
      } else {
        open();
      }
    })
  }

}

DrupalBehavior.register('camc.components', 'globalsearchbar', GlobalSearchBar);
